import type { SVGProps } from 'react';
import * as React from 'react';

const MinusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
    <g id="solid/minus">
      <path
        id="Icon"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.80005 11.9996C4.80005 11.5026 5.20299 11.0996 5.70005 11.0996L18.3 11.0996C18.7971 11.0996 19.2 11.5026 19.2 11.9996C19.2 12.4967 18.7971 12.8996 18.3 12.8996L5.70005 12.8996C5.20299 12.8996 4.80005 12.4967 4.80005 11.9996Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
export default MinusIcon;
